module.exports = __webpack_public_path__ + "img/altar_of_blaze_small.5a9e2948.png";